const SizeLegend = ({
  minIntersection,
  maxIntersection,
  isDownload = false,
}: {
  minIntersection: number;
  maxIntersection: number;
  isDownload?: boolean;
}) => {
  const border = isDownload ? 'border border-gray-500' : '';

  return (
    <div className="flex items-center justify-center gap-8 text-sm">
      <span className={`${isDownload ? 'font-bold' : 'font-semibold'} text-gray-700`}>
        Circle Size (Intersection Count):
      </span>
      <div className="flex items-center gap-2">
        <div
          className={`rounded-full bg-gray-400 ${border}`}
          style={{ width: isDownload ? '12px' : '10px', height: isDownload ? '12px' : '10px' }}
        ></div>
        <span>Min ({minIntersection})</span>
      </div>
      <div className="flex items-center gap-2">
        <div className={`rounded-full bg-gray-400 ${border}`} style={{ width: '25px', height: '25px' }}></div>
        <span>Medium</span>
      </div>
      <div className="flex items-center gap-2">
        <div className={`rounded-full bg-gray-400 ${border}`} style={{ width: '40px', height: '40px' }}></div>
        <span>Max ({maxIntersection})</span>
      </div>
    </div>
  );
};

export default SizeLegend;
